import React, { useEffect } from 'react'
import PostEditorHeader from '../components/header/PostEditorHeader'
import PostEditor from '../components/editor/PostEditor'
import PostEditorFooter from "../components/footer/PostEditorFooter";
import EditorLayers from "../components/layer/EditorLayers";
import AutosaveController from "../components/renderless/AutosaveController";
import {showToast, ToastContainer} from "../components/common/Toast";

function escapeWarning() {
  window.onbeforeunload = (e) => {
    if (window.postChanged) {
      e.preventDefault();
      e.returnValue = '';
    }
  };
}

function preventEventExceptInput(e) {
  e = e || event;
  if (e.target.tagName !== "INPUT") {
    e.preventDefault();
  }
}

function preventDrop() {
  window.addEventListener("dragover", preventEventExceptInput,false);
  window.addEventListener("drop",preventEventExceptInput,false);
}


export default function() {
  useEffect(() => {
    escapeWarning();
    preventDrop();
  }, [])

  return (
    <>
      <AutosaveController />
      
      <div id='kakaoWrap'>
        <PostEditorHeader />
        <ToastContainer />
        <PostEditor />
        <PostEditorFooter />
      </div>

      <EditorLayers />
    </>
  )
}
